export default __webpack_public_path__ + "static/media/not-found.11b89f36.png";